module.exports = __webpack_public_path__ + "static/media/3.18.bd0a8bfb.png";